import './Button.css'

interface ButtonProps {
  children: React.ReactNode
  onClick?: () => void
  disabled?: boolean
  type?: 'button' | 'submit'
  variant?: 'primary' | 'secondary' | 'danger'
  className?: string
  title?: string
}

export function Button({ children, onClick, disabled, type = 'button', variant = 'primary', className, title }: ButtonProps) {
  const baseClassName = `btn btn--${variant}`
  const finalClassName = className ? `${baseClassName} ${className}` : baseClassName
  
  return (
    <button 
      className={finalClassName} 
      onClick={onClick}
      disabled={disabled}
      type={type}
      title={title}
    >
      {children}
    </button>
  )
}